import type { LensCardType } from '~/types/leLens';

/**
 * What each card type is for, in one line.
 *
 * Shared with the plan gate rather than owned by the card editor: a reader
 * retyping sixteen planned cards at once is making the same decision the editor
 * asks for, and two wordings of it would be two different answers.
 */
export const CARD_TYPE_GUIDANCE: Record<LensCardType, string> = {
  metric: 'One headline number.',
  line: 'A measure changing over time.',
  bar: 'Compare a small set of categories.',
  drivers: 'Rank category changes against a comparison period.',
  stacked: 'Totals and their parts together.',
  area: 'The scale of a trend over time.',
  scatter: 'The relationship between two measures.',
  pie: 'Share of a whole, in a few categories.',
  combo: 'Related measures, bars and a line.',
  heatmap: 'A pattern across two categories.',
  boxplot: 'Distribution and spread of a measure.',
  table: 'The returned detail, sortable.',
  insight: 'A short written answer instead of a chart.',
};
